import { usePostMessage } from '../../context/messageContext';
import { Button } from '../../ui';

// [Track Distance] (secondary) / [Capture Distance] (primary) for one refraction position.
const DistanceCollectionButtons = ({ positionIndex, positionData, setPositionData, selectedPosition }) => {
  const postMessage = usePostMessage();

  const startDetections = (positionIndex) => {
    setPositionData({
      ...positionData,
      [positionIndex]: {
        ...positionData[positionIndex],
        tracking: true,
      },
    });
    postMessage({ type: 'detectDistance' });
  };

  const stopDetections = (positionIndex) => {
    postMessage({ type: 'stopDetections' });
    setPositionData({
      ...positionData,
      [positionIndex]: { ...positionData[positionIndex], tracking: false },
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, width: '100%' }}>
      <Button
        variant='secondary'
        size='md'
        block
        disabled={Boolean(Object.keys(positionData).find((element) => positionData[element].tracking)) || positionIndex !== Number(selectedPosition)}
        onClick={() => startDetections(positionIndex)}
      >
        {positionData[positionIndex].tracking ? 'Tracking…' : 'Track Distance'}
      </Button>
      <Button size='md' block disabled={!positionData[positionIndex].tracking} onClick={() => stopDetections(positionIndex)}>
        Capture Distance
      </Button>
    </div>
  );
};

export default DistanceCollectionButtons;
